/**
 * This services help to Actions to get all data about Messages and communication with API Backend
 */

/** import utils */
import {restClient} from "../NTICore/RequestConfig";
import {route} from "../AppCore";

export const saveAgreement = (data) => {
  if (!data) {
    return Promise.reject("Error no data found!");
  } else {
    const url = route.CREATE;

    return restClient(url, "POST", data)
      .then((resp) => {
        return Promise.resolve(resp.data.data);
      })
      .catch((error) => {
        return Promise.reject(error.data);
      });
  }
};

export const saveCommitment = (data) => {
  if (!data) {
    return Promise.reject("Error no data found!");
  } else {
    const url = route.SAVE_COMMITMENT;

    return restClient(url, "POST", data)
      .then((resp) => {
        return Promise.resolve(resp.data.data);
      })
      .catch((error) => {
        return Promise.reject(error.data);
      });
  }
};

/**
 *
 * @param id : partnerAgreementId
 * @return {*}
 */
export const sendMessageToPartner = (id) => {
  if (id) {
    const url = route.SEND_MESSAGE_TO_PARTNER(id);

    return restClient(url, "POST")
      .then((resp) => {
        return Promise.resolve(true);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
};

/**
 *
 * @param id : partnerAgreementId
 * @return {*}
 */
export const sendMessageToInternalCEO = (id) => {
  if (id) {
    const url = route.SEND_MESSAGE_TO_INTERNAL_CEO(id);

    return restClient(url, "POST")
      .then((resp) => {
        return Promise.resolve(true);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
};

/**
 * download partnerAgreement PDF
 * @param id
 * @return {Promise<T>}
 */
export const downloadPDF = (id) => {
  const url = `${route.DOWNLOAD_PDF}/${id}`;

  if (id !== null) {
    return restClient(url, "GET")
      .then((resp) => {
        return Promise.resolve(true);
      })
      .catch((error) => {
        return Promise.reject(false);
      });
  }
};

/**
 * Get States
 * @return {Promise<T>}
 */
export const fetchStates = () => {
  const url = route.FETCH_STATES;
  return restClient(url, "GET")
    .then((resp) => {
      return Promise.resolve(resp.data);
    })
    .catch((error) => {
      return Promise.reject(error.data);
    });
};

/**
 * Get Partner Lead Data (prefill from Monday)
 * @return {Promise<T>}
 */
export const fetchPartnerPrefill = (id) => {
  const url = route.FETCH_PARTNER_PREFILL(id);
  return restClient(url, "GET")
    .then((resp) => {
      return Promise.resolve(resp.data);
    })
    .catch((error) => {
      return Promise.reject(error.data);
    });
};

/**
 * Best-effort "preview opened" ping for the Monday counters — never blocks the flow,
 * so callers should not await/surface its rejection to the user.
 * @param step : "agreement" | "commitment"
 * @param id : the Monday item id
 */
export const trackPreviewOpened = (step, id) => {
  if (!id) return Promise.resolve();
  const url = route.TRACK_PREVIEW(step, id);
  return restClient(url, "POST").catch(() => {});
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/service.js